<template>
  <div class="menu">
    <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
      <el-menu-item index="">全部 </el-menu-item>
      <el-menu-item index="1">审核中 <span style="color: red;" v-if="ordernum.order_status1_num != 0">{{
        ordernum.order_status1_num }}</span></el-menu-item>
      <el-menu-item index="3">审核驳回 <span style="color: red;" v-if="ordernum.order_status3_num != 0">{{
        ordernum.order_status3_num }}</span></el-menu-item>
      <el-menu-item index="5">审核通过 <span style="color: red;" v-if="ordernum.order_status5_num != 0">{{
        ordernum.order_status5_num }}</span></el-menu-item>
      <el-menu-item index="2">已退款 <span style="color: red;" v-if="ordernum.order_status2_num != 0">{{
        ordernum.order_status2_num }}</span></el-menu-item>
    </el-menu>
    <div class="conten" v-loading="loading">
      <div class="index_search">
        <el-input placeholder="请输入订单编号" v-model="queryParams.search_content" clearable @clear="getlist">
          <template slot="append">
            <div @click="getlist">
              搜索
            </div>
          </template>
        </el-input>
      </div>
      <div v-if="ulist.length != 0">
        <div class="cont_tit">
          <div style="text-align: center;flex: 1;">退款信息</div>
          <div class="c_r">
            <div class="i">订单金额</div>
            <div class="i">退款金额</div>
            <div class="i">交易状态</div>
            <div class="i">交易操作</div>
          </div>
        </div>
        <div>
          <div class="ove" id="outerDiv">
            <div class="list_item" v-for="(item, index) in ulist" :key="index">
              <div class="item_tit">
                <div class="tit_l">
                  <img :src="item.avatar" alt="" srcset="">
                  <div class="tit_name">{{ item.nickname }}</div>
                </div>
                <img @click="openTim(item)" class="ricon" src="@/assets/user/uxx.png" alt="" srcset="">
              </div>
              <div class="list_item-cont_tit">
                <div class="item_l">
                  <img src="@/assets/user/u1.png" alt="">
                  <div class="itext">
                    <div>订单编号：{{ item.order_no }}</div>
                    <div class="yy">
                      退款原因：{{ item.refund_reason }}
                    </div>
                  </div>
                </div>
                <div class="c_r">
                  <div class="i i1">
                    <div>￥{{ item.order_money }}</div>
                  </div>
                  <div class="i i1" style="color: red;">
                    <div>￥{{ item.refund_money }}</div>
                  </div>
                  <div class="i i1">
                    <div v-if="item.status == 1">审核中</div>
                    <div v-else-if="item.status == 2">已退款</div>
                    <div v-else-if="item.status == 3">审核驳回</div>
                    <div v-else-if="item.status == 4">取消退款</div>
                    <div v-else-if="item.status == 5">审核通过</div>
                  </div>
                  <div class="i i1">
                    <div>
                      <div class="btn2" v-if="item.status == 1" @click="handlechetk(item)">撤销申请</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="itime">
                发起时间：{{ item.createtime | formatDate }}
              </div>
              <div class="tk" v-if="item.status == 3">
                驳回原因：{{ item.refund_reject_reason }}
              </div>
            </div>

          </div>
        </div>

        <div class="pagination">
          <pagination v-show="total > 0" :total="total" :page.sync="queryParams.page" :limit.sync="queryParams.limit"
            @pagination="getlist" />
        </div>
      </div>
    </div>
    <div class="k" v-if="nolist">
      <div>
        <img src="@/assets/user/k.png" alt="" srcset="">
        <div class="text">暂无订单</div>
      </div>
    </div>

    <el-dialog class="dialogstim" :visible.sync="popup.showTim" width="1122px">
      <TimView v-if="popup.showTim" :chatID="chatID" :openNum="1"></TimView>
    </el-dialog>
  </div>
</template>

<script>
import { userRefundList, userRefundOrderNum, cancelRefund } from '@/api/index.js'
import TimView from '@/components/TimView/index.vue'
export default {
  components: { TimView },
  name: '',
  data() {
    return {
      activeIndex: '',
      total: 0,
      nolist: false,
      queryParams: {
        page: 1,
        limit: 10,
        status: '', //退款状态:1=待审核,2=已退款,3=驳回,5=审核通过
        search_content: ''
      },
      loading: false,
      ulist: [],
      popup: {
        showTim: false, //客服弹窗
      },
      ordernum: {}
    }
  },
  computed: {
    isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    }
  },
  mounted() {
    this.getlist()
  },
  methods: {
    //打开聊天
    openTim(item) {
      if (this.isMobile) {
        this.$dataConver.gopage(item.supplier_id)
        return
      }
      this.popup.showTim = true
      this.chatID = item.supplier_id
    },
    //头部切换
    handleSelect(e) {
      this.queryParams.status = e
      this.queryParams.page = 1
      this.getlist()
    },
    getlist() {
      this.loading = false
      userRefundList(this.queryParams).then(res => {
        if (res.code == 1) {
          this.ulist = res.data.list
          this.total = res.data.total
          let total = Math.ceil(res.data.total / this.queryParams.limit);
          this.nolist = total == 0
          this.loading = false
          if (res.data.list.length != 0) {
            this.$nextTick(() => {
              document.getElementById('outerDiv').scrollTop = 0
            });
          }
          userRefundOrderNum().then(ress => {
            this.ordernum = ress.data
          })
        }

      })
    },
    //撤销退款
    handlechetk(item) {
      this.$confirm('确定要撤销当前订单退款吗？', '提示', {
        confirmButtonText: '确定',
        type: 'warning'
      }).then(() => {
        cancelRefund({ refund_id: item.id }).then(res => {
          if (res.code == 1) {
            this.$modal.msgSuccess(`订单已撤销`);
            this.queryParams.page = 1
            this.getlist()
          }
        })
      }).catch(() => { });

    }
  },
}
</script>
<style lang='scss' scoped>
.dialogstim ::v-deep .el-dialog__body {
  padding: 12px 0px 0px 0px !important;
}

.dialogstim ::v-deep .el-dialog__header {
  padding: 20px;
}

.el-menu--horizontal>.el-menu-item.is-active {
  border-bottom: 2px solid #FFDB0C;
  font-size: 16px;
}

.el-menu--horizontal>.el-menu-item {
  font-size: 14px;
}

.el-dropdown-menu__item,
.el-menu-item {
  padding: 0px 50px;
}

.conten {
  padding: 20px;
  box-sizing: border-box;

  .index_search {
    display: flex;
    width: 560px;
    height: 36px;

    ::v-deep .el-input-group__append,
    .el-input-group__prepend {
      background-color: #FFDB0C;
      color: #000000;
      cursor: pointer;
    }

  }

  .cont_tit {
    display: flex;
    height: 38px;
    background: #F7F8FA;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #DEDEDE;
    align-items: center;
    margin: 10px 0px 6px 0px;
    line-height: 38px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #000000;
    justify-content: space-between;

    .c_r {
      display: flex;

      .i {
        width: 120px;
        text-align: center;
      }
    }
  }

  .ove {
    height: 500px;
    overflow: auto;

    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }

    &::-webkit-scrollbar-thumb {
      background: rgba(144, 147, 153, 0.3);
      cursor: pointer;
      border-radius: 4px;
    }

    .list_item {
      background: #FFFFFF;
      border-radius: 4px;
      border: 1px solid #DEDEDE;
      margin-bottom: 6px;

      .item_tit {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: #F7F8FA;
        padding: 6px 9px;
        box-sizing: border-box;

        .ricon {
          width: 16px;
          height: 16px;
          cursor: pointer;
        }

        .tit_l {
          display: flex;
          align-items: center;

          img {
            width: 26px;
            height: 26px;
            border-radius: 4px;
            border: 1px solid #DEDEDE;
          }

          .tit_name {
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #000000;
            line-height: 16px;
            margin-left: 6px;
          }
        }
      }

      .list_item-cont_tit {
        display: flex;
        align-items: center;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #000000;
        justify-content: space-between;
        height: 76px;
        border-bottom: 1px solid #DEDEDE;
        align-items: center;

        .c_r {
          display: flex;
          align-items: center;
          height: 76px;

          .i1 {
            display: flex;
            justify-content: center;
            align-items: center;
          }

          .i {
            width: 120px;
            text-align: center;
            border-left: 1px solid #DEDEDE;
            height: 76px;
          }

          .btn1 {
            width: 74px;
            height: 30px;
            background: #FFDB0C;
            border-radius: 6px 6px 6px 6px;
            text-align: center;
            line-height: 30px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #000000;
            margin-bottom: 6px;
            cursor: pointer;
          }

          .btn2 {
            width: 74px;
            height: 30px;
            border-radius: 6px 6px 6px 6px;
            text-align: center;
            line-height: 30px;
            border: 1px solid #DEDEDE;
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #000000;
            cursor: pointer;
          }
        }

        .item_l {
          display: flex;
          align-items: center;
          margin-left: 15px;

          .itext {
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #000000;
            margin-left: 15px;

            .yy {
              font-family: PingFang SC, PingFang SC;
              font-weight: 500;
              font-size: 14px;
              color: #ADAAAA;
              margin-top: 4px;
            }

          }
        }
      }

      .itime {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #000000;
        line-height: 16px;
        padding: 13px;
        box-sizing: border-box;
      }

      .tk {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: red;
        line-height: 16px;
        padding: 13px;
        box-sizing: border-box;
        border-top: 1px solid #DEDEDE;

      }
    }


  }


}

.pagination {
  text-align: right;

  ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #FFDB0C;
  }

  ::v-deep .el-pagination.is-background .el-pager li:not(.disabled):hover {
    color: #000000;
  }

  .pagination-container {
    padding: 10px 10px 0px 10px;
  }
}

.k {
  text-align: center;
  height: 530px;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 224px;
    height: 224px;
  }

  .text {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #ADAAAA;
    margin-top: 20px;
  }
}

.zfpop {
  .ztit {
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    font-size: 24px;
    color: #000000;
    text-align: center;
  }

  .dimg {
    width: 290px;
    height: 290px;
    border-radius: 10px 10px 10px 10px;
    border: 1px solid #DEDEDE;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 20px auto;

    img {
      width: 270px;
      height: 270px;
    }
  }

  .ts {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #ADAAAA;
    text-align: center;
  }
}

.tkpop {
  .tit {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 20px;
    color: #000000;
    line-height: 23px;
  }

  .tkOne {
    margin-top: 20px;
    background: #FFFFFF;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #DEDEDE;
    padding: 13px;
    box-sizing: border-box;

    .tflex {
      display: flex;
      align-items: center;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #000000;

      img {
        width: 26px;
        height: 26px;
        margin-right: 8px;
        border-radius: 4px;
      }
    }

    .dd {
      margin-top: 10px;
    }


  }

  .tkTwo {
    background: #FFFFFF;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #DEDEDE;
    padding: 26px 19px;
    box-sizing: border-box;
    margin-top: 10px;

    .jk {
      display: flex;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #000000;
      align-items: center;
    }

    .jk::before {
      content: '*';
      color: red;
    }

    .ts {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #ADAAAA;
      border-bottom: 1px solid #DEDEDE;
      margin: 10px 0px;
      padding-bottom: 10px;
    }

    .tk {
      display: flex;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #000000;
      align-items: center;

      input {
        width: 100%;
        font-weight: 500;
        font-size: 16px;
        color: #000000;
        border: none;
      }
    }

    .tk::before {
      content: '*';
      color: red;
    }
  }

}
</style>